import React, { useState, useEffect } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { Provider } from "react-redux";
import { getLoggedInUser } from "./services/authService";
import MSPInformation from "./pages/MSPInformation";
import CustomerInformation from "./pages/CustomerInformation";
import AppLayout from "./components/layout/AppLayout";
import RouteGuard from "./components/RouteGuard";
import CustomerDashboard from "./pages/customer-dashboard";
import MspDashboard from "./pages/msp-dashboard";
import NotificationsOverlay from "./components/NotificationOverlay";
import { store } from "./store";

export default function App() {
  return (
    <Provider store={store}>
      <RouteGuard>
        <NotificationsOverlay />

        <Routes>
          <Route element={<AppLayout />}>
            <Route path="/msps" element={<MspDashboard />} />
            <Route path="/msps/:mspId/customers" element={<MspDashboard />} />

            <Route path="/customers" element={<CustomerDashboard />} />

            {/* Common detail routes */}
            <Route path="/msp/:mspId" element={<MSPInformation />} />
            <Route path="/msp/info" element={<MSPInformation />} />
            <Route
              path="/msp/:mspId/customer/:customerId"
              element={<CustomerInformation />}
            />

            <Route path="/" element={<NavigateToDashboard />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Route>
        </Routes>
      </RouteGuard>
      <ToastContainer />
    </Provider>
  );
}

function NavigateToDashboard() {
  const [role, setRole] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      const user = await getLoggedInUser();
      setRole(user?.customRole ?? null);
      setLoading(false);
    })();
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-white p-4">Loading...</div>
      </div>
    );
  }
  if (role === "superadmin") {
    return <Navigate to="/msps" replace />;
  } else if (role === "msp") {
    return <Navigate to="/customers" replace />;
  } else {
    // Fallback or logout
    return <Navigate to="/customers" replace />;
  }
}
